import React, { useEffect, useContext } from 'react';
import { Container, Grid, Box } from '@mui/material';
import '../styles/css/AboutMe.css';
// Add import for image
import whoamiImage from '../styles/images/whoami1.webp';
// Add import for framer-motion
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { LanguageContext } from '../App';

const AboutMe = () => {
  // Add animation controls
  const controls = useAnimation();
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true
  });

  // Trigger animations when section comes into view
  useEffect(() => {
    if (inView) {
      controls.start('visible');
    }
  }, [controls, inView]);

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        damping: 15,
        stiffness: 100
      }
    }
  };

  const imageVariants = {
    hidden: { x: -50, opacity: 0 },
    visible: {
      x: 0,
      opacity: 1,
      transition: {
        type: "spring",
        damping: 15,
        stiffness: 100
      }
    }
  };

  const { language, translations } = useContext(LanguageContext);

  return (
    <Container className="about-container">
      <motion.div
        initial="hidden"
        animate={controls}
        variants={containerVariants}
        ref={ref}
      >
        
        
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} md={4}>
            <motion.div variants={imageVariants} className="about-image-container">
              <a href="https://www.instagram.com/p/C8gdNOzI8ZX/" target="_blank" rel="noreferrer">
                <img
                  src={whoamiImage}
                  alt="Photographer"
                  className="about-image"
                  style={{                     
                    height: '500px', 
                    objectFit: 'cover',
                    borderRadius: '10px' 
                  }}
                />
              </a>
              
            </motion.div>
            <p className="about-image-caption">
              {translations[language].aboutImageCaption} 😄
            </p>
          </Grid>
          <Grid item xs={12} md={8}>
            <Box className="about-content">
              <motion.div variants={itemVariants}>
                <h3 className="about-greeting">
                  {translations[language].aboutGreeting}
                </h3>
              </motion.div>
              
              
              
              {/* Wrap each paragraph in motion.div */}
              <motion.div variants={itemVariants}>
                <p className="about-paragraph">
                  {translations[language].aboutParagraph1}
                </p>
              </motion.div>
              
              <motion.div variants={itemVariants}>
                <p className="about-paragraph">
                  {translations[language].aboutParagraph2}
                </p>
              </motion.div>
              
              <motion.div variants={itemVariants}>
                <p className="about-paragraph">
                  {translations[language].aboutParagraph3}
                </p>
              </motion.div>
              
              <motion.div variants={itemVariants}>
                <p className="about-paragraph">
                  {translations[language].aboutParagraph4}
                </p>
              </motion.div>

              { translations[language].aboutParagraph5 && (
              <motion.div variants={itemVariants}>
                <p className="about-paragraph">
                  {translations[language].aboutParagraph5}
                </p>
              </motion.div>
              )}
            </Box>
          </Grid>
        </Grid>
      </motion.div>
    </Container>
  );
}

export default AboutMe;
